
import axios from 'axios'
export default {
  name: 'searchBar',
  data () {
    return {
      randomProduct: '搜索商品'
    }
  },
  created () {
    this.fetchRandomKeyword()
  },
  methods: {
    async fetchRandomKeyword () {
      try {
        const res = await axios.get('config/search-keyword')
        if (res.data.code === 200 && res.data.data) {
          const keywords = res.data.data
          // 支持数组或单个字符串
          if (Array.isArray(keywords) && keywords.length > 0) {
            this.randomProduct = keywords[Math.floor(Math.random() * keywords.length)]
          } else if (typeof keywords === 'string') {
            this.randomProduct = keywords
          }
        }
      } catch (e) {
        // 使用默认值
        const defaults = ['轮胎', '机油', '电瓶', '刹车片']
        this.randomProduct = defaults[Math.floor(Math.random() * defaults.length)]
      }
    },
    toRecommend (ranPro) {
      // 推荐词只作 placeholder 提示（不写 input value、不自动搜索）；source=direct_search 允许搜索页自动 focus
      this.$router.push({
        path: '/search',
        query: { placeholder: ranPro, source: 'direct_search' }
      })
    }
  }
}
